import { Injectable } from "@angular/core";
import { PageClient, PageTypeEnum, PageViewModel } from "src/domain/client";

@Injectable({
  providedIn: "root",
})
export class PageService {
  constructor() {}

  getThankYouPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.ThankYou);
  }

  getNotFoundPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.NotFound);
  }

  getStartPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.Start);
  }

  getTermsPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.Terms);
  }

  getSearchPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.Search);
  }

  getFaqPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.FAQ);
  }

  getProductPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.Product);
  }

  getCheckoutPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.Checkout);
  }

  getCategoryPage(brandId: number | undefined): Promise<PageViewModel> {
    return new PageClient().page(brandId, PageTypeEnum.Category);
  }
}
